import { render, staticRenderFns } from "./notify_is_importing.vue?vue&type=template&id=0bf1d33e&"
import script from "./notify_is_importing.vue?vue&type=script&lang=tsx&"
export * from "./notify_is_importing.vue?vue&type=script&lang=tsx&"
import style0 from "./notify_is_importing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports